import React from "react";
import { motion } from "framer-motion";
import { Search, DollarSign, Truck, X } from "lucide-react";

// Cream-theme search + filter panel that sits above the grid.
export default function SearchPanel({
  searchTerm, setSearchTerm,
  selectedBrand, setSelectedBrand,
  brands = [],
  viewMode, setViewMode,
  salesCount = 0, rentalsCount = 0,
  onClear,
  hideRentalToggle = false,
}) {
  const hasFilters = searchTerm || selectedBrand;
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.6 }}
      className="max-w-6xl mx-auto px-6 md:px-12 -mb-8 relative z-20"
      data-testid="search-panel"
    >
      <div className="rounded-2xl bg-white border border-[#0B1623]/8 shadow-[0_20px_50px_rgba(11,22,35,0.06)] p-5 md:p-6">
        {!hideRentalToggle && (
          <div className="flex items-center justify-center gap-2 mb-5">
            <button
              onClick={() => setViewMode("sale")}
              className={`px-6 py-2.5 rounded-full font-rajdhani font-semibold text-sm uppercase tracking-[0.15em] transition-all flex items-center gap-2 ${
                viewMode === "sale"
                  ? "bg-[#0B1623] text-white"
                  : "text-[#0B1623]/60 hover:text-[#0B1623] hover:bg-[#0B1623]/5"
              }`}
              data-testid="search-view-sale"
            >
              <DollarSign className="w-4 h-4" />
              Venta
              <span className="text-xs opacity-60">({salesCount})</span>
            </button>
            <button
              onClick={() => setViewMode("rental")}
              className={`px-6 py-2.5 rounded-full font-rajdhani font-semibold text-sm uppercase tracking-[0.15em] transition-all flex items-center gap-2 ${
                viewMode === "rental"
                  ? "bg-[#0B1623] text-white"
                  : "text-[#0B1623]/60 hover:text-[#0B1623] hover:bg-[#0B1623]/5"
              }`}
              data-testid="search-view-rental"
            >
              <Truck className="w-4 h-4" />
              Renta
              <span className="text-xs opacity-60">({rentalsCount})</span>
            </button>
          </div>
        )}

        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex-1 relative">
            <Search className="absolute left-5 top-1/2 -translate-y-1/2 w-5 h-5 text-[#0B1623]/40" />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Busca por marca, modelo o versión…"
              className="w-full pl-14 pr-5 py-4 rounded-full bg-[#FFFFFF] border border-[#0B1623]/10 text-[#0B1623] placeholder-[#0B1623]/40 font-manrope focus:bg-white focus:border-[#F09A21] focus:outline-none transition-colors"
              data-testid="search-input-premium"
            />
          </div>
          <div className="md:w-56 relative">
            <select
              value={selectedBrand}
              onChange={(e) => setSelectedBrand(e.target.value)}
              className="w-full px-5 py-4 rounded-full bg-[#FFFFFF] border border-[#0B1623]/10 text-[#0B1623] font-manrope focus:bg-white focus:border-[#F09A21] focus:outline-none transition-colors appearance-none cursor-pointer"
              data-testid="brand-filter-premium"
            >
              <option value="">Todas las marcas</option>
              {brands.map((b, idx) => (<option key={idx} value={b}>{b}</option>))}
            </select>
          </div>
          {hasFilters && (
            <button
              onClick={onClear}
              className="px-5 py-4 rounded-full border border-[#0B1623]/15 text-[#0B1623]/70 hover:text-[#0B1623] hover:border-[#0B1623]/30 transition-colors flex items-center gap-2 font-manrope"
              data-testid="clear-filters-premium"
            >
              <X className="w-4 h-4" /> Limpiar
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
}
